import { Download } from "lucide-react";

export const DigitalBadge = () => {
  return (
    <div className="absolute top-2 left-2 bg-blue-600 text-white px-2 py-0.5 rounded-md text-xs font-semibold flex items-center gap-1 shadow-sm z-10">
      <Download className="h-3 w-3" />
      <span>Digital</span>
    </div>
  );
};
